/**
 * @file 操作cookie
 */
import { isObject } from './type';
/**
 * 获取cookie
 * @param key 只获取某个key对应的value
 */
export function getCookie(key) {
    var cookie = getCookieToObj();
    return key ? cookie[key] : cookie;
}
export function setCookie(key, value, days, isEncode, host) {
    if (days === void 0) { days = 0; }
    if (isEncode === void 0) { isEncode = true; }
    if (host === void 0) { host = location.host; }
    var valueStr = isObject(value) ? JSON.stringify(value) : String(value);
    valueStr = isEncode ? encodeURIComponent(valueStr) : valueStr;
    var expires = '';
    if (days > 0) {
        var d = new Date();
        var offset = 8;
        var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        var nd = utc + (3600000 * offset);
        var exp = new Date(nd);
        exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "expires=".concat(exp.toUTCString(), ";");
    }
    document.cookie = "".concat(key, "=").concat(valueStr, ";path=/;").concat(expires, ";domain=").concat(host);
}
export function delCookie(key, host) {
    if (host === void 0) { host = location.host; }
    var preVal = getCookie(key);
    if (preVal) {
        document.cookie = "".concat(key, "=").concat(preVal, ";domain=").concat(host, ";expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;");
    }
}
export function clearCookie(host) {
    if (host === void 0) { host = location.host; }
    Object.keys(getCookie()).forEach(function (key) { return delCookie(key, host); });
}
function getCookieToObj() {
    var cookie = document.cookie;
    var cookieArr = cookie.split(';');
    var res = {};
    cookieArr.forEach(function (item) {
        var temArr = item.split('=');
        res[temArr[0].trim()] = decodeURIComponent(temArr[1]);
    });
    return res;
}
